class RegistrationCollection extends require("lib/static-shim").default(
  require("lib/core/collection").default
) {
  static initClass() {
    this.prototype.model = require("./registration").default
  }

  url() {
    // note: this used to call /api/private/registration/ when no `resource_id` was provided, but we have since removed
    //   that since that case wasn't being hit on either the client OR the backend
    return this.urlRoot(
      `api/private/library/resource/${this.options.resource_id}/registration/`
    )
  }
}
RegistrationCollection.initClass()

export default RegistrationCollection
